/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "azure-devops-ui/Core/Observable", "azure-devops-ui/Core/Util/String", "azure-devops-ui/MasterDetails", "azure-devops-ui/MasterDetailsContext", "azure-devops-ui/Spinner", "history", "react", "simple-query-string", "../../Resources", "../Constants", "../FluxCommon/ActionsCreatorManager", "../FluxCommon/StoreManager", "../ImageDetails/ImageDetails", "../ImageDetails/ImageDetailsActionsCreator", "../ImageDetails/ImageDetailsStore", "../KubeFactory", "../Selection/SelectionActionCreator", "../Utils", "./PodsActionsCreator", "./PodsLeftPanel", "./PodsRightPanel", "./PodsStore"], function (require, exports, Observable_1, String_1, MasterDetails_1, MasterDetailsContext_1, Spinner_1, history_1, React, queryString, Resources, Constants_1, ActionsCreatorManager_1, StoreManager_1, ImageDetails_1, ImageDetailsActionsCreator_1, ImageDetailsStore_1, KubeFactory_1, SelectionActionCreator_1, Utils_1, PodsActionsCreator_1, PodsLeftPanel_1, PodsRightPanel_1, PodsStore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PodsDetails = /** @class */ (function (_super) {
        __extends(PodsDetails, _super);
        function PodsDetails(props) {
            var _this = _super.call(this, props) || this;
            _this._onPodSelectionChange = function (event, selectedPod, selectedView) {
                var routeValues = __assign({}, queryString.parse(_this._history.location.search));
                routeValues["uid"] = selectedPod.metadata.uid;
                routeValues["view"] = selectedView || "pod-details" /* PodsDetailsKey */;
                _this._history.replace({
                    pathname: _this._history.location.pathname,
                    search: queryString.stringify(routeValues)
                });
                var parentItem = {
                    name: _this.state.parentName || "",
                    kind: _this.state.parentKind || ""
                };
                _this.setState({
                    selectedPod: selectedPod,
                    masterDetailsContext: new MasterDetailsContext_1.BaseMasterDetailsContext(_this._getMasterDetailsContext(parentItem, selectedPod, _this.state.pods), _this._onParentBackButtonClick)
                });
            };
            _this._onParentBackButtonClick = function () {
                var selectionActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(SelectionActionCreator_1.SelectionActionsCreator);
                selectionActionCreator.selectItem({
                    itemUID: _this.props.parentUid,
                    selectedItemType: Utils_1.Utils.getItemTypeKeyFromKind(_this.state.parentKind || ""),
                    showSelectedItem: true,
                    item: undefined,
                    properties: { parentUid: "", serviceSelector: "", serviceName: "" } // This will delete these values if they are present in the url
                });
                return false;
            };
            _this._showImageDetails = function (imageId) {
                var showImageDetails = function (imageDetails) {
                    _this.setState({
                        selectedImageDetails: imageDetails
                    });
                };
                ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ImageDetailsActionsCreator_1.ImageDetailsActionsCreator).getImageDetails(imageId, showImageDetails);
            };
            _this._hideImageDetails = function () {
                _this.setState({
                    selectedImageDetails: undefined
                });
            };
            _this._setHasImageDetails = function () {
                _this.setState({});
            };
            _this._markTTI = function (additionalProperties) {
                if (!_this._isTTIMarked) {
                    KubeFactory_1.getTelemetryService().scenarioEnd(Constants_1.Scenarios.PodsDetails, additionalProperties);
                    _this._isTTIMarked = true;
                    _this._isScenarioOpen = false;
                }
            };
            _this._onRightPaneTabChange = function () {
                if (_this._isScenarioOpen) {
                    //close current scenario and reopen a new open
                    KubeFactory_1.getTelemetryService().scenarioEnd(Constants_1.Scenarios.PodsDetails);
                }
                KubeFactory_1.getTelemetryService().scenarioStart(Constants_1.Scenarios.PodsDetails);
                _this._isScenarioOpen = true;
                _this._isTTIMarked = false;
            };
            _this._isScenarioOpen = false;
            _this._isTTIMarked = false;
            KubeFactory_1.getTelemetryService().scenarioStart(Constants_1.Scenarios.PodsDetails);
            _this._isScenarioOpen = true;
            _this._history = history_1.createBrowserHistory();
            var notifyViewChanged = function (parentName, parentKind) {
                // In pod details, we show all pods in the parent. So the view owner is the parent, not the pod
                if (parentName && parentKind && props.notifyViewChanged) {
                    var clonedQueryParams = __assign({}, queryString.parse(_this._history.location.search));
                    delete clonedQueryParams["parentUid"];
                    delete clonedQueryParams["serviceSelector"];
                    delete clonedQueryParams["serviceName"];
                    var itemTypeKey = Utils_1.Utils.getItemTypeKeyFromKind(parentKind);
                    clonedQueryParams["type"] = itemTypeKey;
                    clonedQueryParams["uid"] = props.parentUid;
                    var paramsString = queryString.stringify(clonedQueryParams);
                    var url = _this._history.location.pathname + "?" + paramsString;
                    props.notifyViewChanged([{
                            id: itemTypeKey + props.parentUid,
                            displayName: parentName,
                            url: url
                        }]);
                }
            };
            _this._imageDetailsStore = StoreManager_1.StoreManager.GetStore(ImageDetailsStore_1.ImageDetailsStore);
            _this._imageDetailsStore.addListener(Constants_1.ImageDetailsEvents.HasImageDetailsEvent, _this._setHasImageDetails);
            _this._podsStore = StoreManager_1.StoreManager.GetStore(PodsStore_1.PodsStore);
            var parentKind = undefined, parentName = undefined, filteredPods = [], selectedPod = undefined;
            var podsList = props.serviceSelector ? _this._podsStore.getState().podListByLabel[props.serviceSelector] : _this._podsStore.getState().podsList;
            var getPodProperties = function (pods) {
                if (pods) {
                    var filteredPods_1 = props.serviceSelector
                        ? pods
                        : pods.filter(function (p) { return Utils_1.Utils.isOwnerMatched(p.metadata, props.parentUid.toLowerCase()); });
                    if (filteredPods_1.length) {
                        var selectedPod_1 = props.selectedPodUid ? filteredPods_1.find(function (p) { return p.metadata.uid.toLowerCase() === props.selectedPodUid.toLowerCase(); }) : filteredPods_1[0];
                        var parentKind_1 = undefined;
                        var parentName_1 = undefined;
                        if (props.serviceName && props.serviceSelector) {
                            parentName_1 = props.serviceName;
                            parentKind_1 = "Service";
                        }
                        else {
                            var parent_1 = filteredPods_1[0].metadata.ownerReferences.find(function (o) { return o.uid.toLowerCase() === props.parentUid.toLowerCase(); });
                            if (parent_1) {
                                parentKind_1 = parent_1.kind;
                                parentName_1 = parent_1.name;
                            }
                        }
                        return {
                            parentKind: parentKind_1,
                            parentName: parentName_1,
                            pods: filteredPods_1,
                            selectedPod: selectedPod_1
                        };
                    }
                }
                return {};
            };
            if (!podsList || !podsList.items) {
                var podsActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(PodsActionsCreator_1.PodsActionsCreator);
                _this._podsFetchEventName = props.serviceSelector ? Constants_1.PodsEvents.LabelledPodsFetchedEvent : Constants_1.PodsEvents.PodsFetchedEvent;
                _this._podsFetchHandler = function () {
                    _this._removePodsFetchListener();
                    var podsStoreState = _this._podsStore.getState();
                    var fetchedPodList = props.serviceSelector
                        ? podsStoreState.podListByLabel[props.serviceSelector]
                        : podsStoreState.podsList;
                    if (fetchedPodList && fetchedPodList.items) {
                        var properties = getPodProperties(fetchedPodList.items);
                        var imageList = Utils_1.Utils.getImageIdsForPods(properties.pods || []);
                        // adding breadcrumb when parent object is fetched on pod view refresh
                        notifyViewChanged(properties.parentName, properties.parentKind);
                        var parentItem_1 = {
                            name: properties.parentName || "",
                            kind: properties.parentKind || ""
                        };
                        var handlerMasterDetailsContext = _this._getMasterDetailsContext(parentItem_1, properties.selectedPod, properties.pods);
                        _this.setState({
                            parentKind: properties.parentKind,
                            parentName: properties.parentName,
                            pods: properties.pods,
                            selectedPod: properties.selectedPod,
                            isLoading: podsStoreState.isLoading,
                            imageList: imageList,
                            masterDetailsContext: new MasterDetailsContext_1.BaseMasterDetailsContext(handlerMasterDetailsContext, _this._onParentBackButtonClick)
                        });
                    }
                };
                _this._podsStore.addListener(_this._podsFetchEventName, _this._podsFetchHandler);
                _this._podFetchEventActive = true;
                if (props.serviceSelector) {
                    podsActionCreator.getPods(KubeFactory_1.KubeFactory.getKubeService(), props.serviceSelector, true);
                }
                else {
                    podsActionCreator.getPods(KubeFactory_1.KubeFactory.getKubeService());
                }
            }
            else {
                var properties = getPodProperties(podsList.items);
                parentKind = properties.parentKind;
                parentName = properties.parentName;
                filteredPods = properties.pods;
                selectedPod = properties.selectedPod;
            }
            notifyViewChanged(parentName, parentKind);
            var parentItem = {
                name: parentName || "",
                kind: parentKind || ""
            };
            var masterDetailsContext = _this._getMasterDetailsContext(parentItem, selectedPod, filteredPods);
            _this.state = {
                parentKind: parentKind,
                parentName: parentName,
                pods: filteredPods,
                selectedPod: selectedPod,
                selectedImageDetails: undefined,
                isLoading: !podsList || !podsList.items,
                masterDetailsContext: new MasterDetailsContext_1.BaseMasterDetailsContext(masterDetailsContext, _this._onParentBackButtonClick)
            };
            return _this;
        }
        PodsDetails.prototype._getMasterDetailsContext = function (parent, selectedPod, pods) {
            var _this = this;
            var subTitle = String_1.localeFormat(Resources.PodDetailsSubheader, parent.kind);
            return {
                key: "pod-details",
                masterPanelContent: {
                    renderContent: function (parentItem, selectedPod) { return (React.createElement(PodsLeftPanel_1.PodsLeftPanel, { pods: pods || [], parentName: parentItem.name, parentKind: parentItem.kind, selectedPodName: selectedPod && selectedPod.value ? selectedPod.value.metadata.name : "", onSelectionChange: _this._onPodSelectionChange })); },
                    renderHeader: function () { return React.createElement(MasterDetails_1.MasterPanelHeader, { title: parent.name, subTitle: subTitle }); },
                    onBackButtonClick: this._onParentBackButtonClick
                },
                detailsContent: {
                    renderContent: function (item) { return (React.createElement(PodsRightPanel_1.PodsRightPanel, { key: item.metadata.uid, pod: item, showImageDetails: _this._showImageDetails, markTTICallback: _this._markTTI, notifyTabChange: _this._onRightPaneTabChange })); }
                },
                selectedMasterItem: new Observable_1.ObservableValue(selectedPod || {}),
                parentItem: parent
            };
        };
        PodsDetails.prototype.render = function () {
            if (this.state.selectedImageDetails) {
                return React.createElement(ImageDetails_1.ImageDetails, { imageDetails: this.state.selectedImageDetails, onBackButtonClick: this._hideImageDetails });
            }
            if (this.state.isLoading) {
                return React.createElement(Spinner_1.Spinner, { className: "flex flex-grow loading-pods", size: "large" /* large */, label: Resources.LoadingPodsSpinnerLabel });
            }
            var selectedPod = this.state.selectedPod;
            if (!selectedPod && this.state.pods && this.state.pods.length > 0) {
                selectedPod = this.state.pods[0];
            }
            return (selectedPod && this.state.masterDetailsContext ?
                React.createElement(MasterDetailsContext_1.MasterDetailsContext.Provider, { value: this.state.masterDetailsContext },
                    React.createElement("div", { className: "pod-details flex-row flex-grow scroll-hidden" },
                        React.createElement(MasterDetails_1.MasterPanel, { showOnSmallScreens: true }),
                        React.createElement(MasterDetails_1.DetailsPanel, null)))
                : React.createElement("div", { className: "zero-pods-text-container" }, Resources.NoPodsFoundText));
        };
        PodsDetails.prototype.componentDidUpdate = function (prevProps, prevState) {
            // fetch hasImageDetailsData if we directly refresh and land on WorkloadDetails
            var imageService = KubeFactory_1.KubeFactory.getImageService();
            if (imageService && this.state.imageList && this.state.imageList.length > 0) {
                var hasImageDetails = this._imageDetailsStore.hasImageDetails(this.state.imageList[0]);
                if (hasImageDetails === undefined) {
                    ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ImageDetailsActionsCreator_1.ImageDetailsActionsCreator).setHasImageDetails(imageService, this.state.imageList);
                }
            }
        };
        PodsDetails.prototype.componentWillUnmount = function () {
            this._imageDetailsStore.removeListener(Constants_1.ImageDetailsEvents.HasImageDetailsEvent, this._setHasImageDetails);
            this._removePodsFetchListener();
        };
        PodsDetails.prototype._removePodsFetchListener = function () {
            if (this._podFetchEventActive && this._podsFetchEventName && this._podsFetchHandler) {
                this._podFetchEventActive = false;
                this._podsStore.removeListener(this._podsFetchEventName, this._podsFetchHandler);
            }
        };
        return PodsDetails;
    }(React.Component));
    exports.PodsDetails = PodsDetails;
});
